
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { formatCurrency } from "@/utils/currency-data";

interface RequestSummaryCardProps {
  merchant: string;
  amount: number;
  currency?: string;
  orderNumber?: string;
  tone?: string;
  issue: string;
}

const RequestSummaryCard = ({ 
  merchant, 
  amount, 
  currency = 'USD',
  orderNumber, 
  tone, 
  issue 
}: RequestSummaryCardProps) => {
  // Format the amount with currency
  const formattedAmount = formatCurrency(amount, currency);
  
  return (
    <Card className="mb-4">
      <CardHeader>
        <CardTitle>Your Refund Request</CardTitle>
        <CardDescription>
          Here's the summary of your refund request
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Seller</p>
              <p>{merchant}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Amount</p>
              <p>{formattedAmount}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Currency</p>
              <p>{currency}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Order Number</p>
              <p>{orderNumber ? orderNumber : <span className="text-muted-foreground italic">Not provided</span>}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Tone</p>
              <p className="capitalize">{tone || "Polite"}</p>
            </div>
          </div>
          
          <div>
            <p className="text-sm font-medium text-muted-foreground mb-1">Issue Description</p>
            <p className="text-sm">{issue}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default RequestSummaryCard;
